import { Input } from 'antd'
import { inputTextSchema } from '../schemas'
import { withFormItem } from './form-item'

export const InputTextRenderer = withFormItem(inputTextSchema)(childrenProps => {
  return <Input {...childrenProps} />
})
